import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Accordion } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { FaSearch, FaRegQuestionCircle, FaArrowRight } from "react-icons/fa";
import Footer from "./footer";
import Navbar from "./Navbar";
import { BASE_URL_API_TRANXT_UAT_API } from "../Utils/Constant";
import faqImage from "../Images/images/billpunch_faq.png";
import "./HomeLayout.css";
import "./ResourcePages.css";

const Billpuncfaq = () => {
  const [faq, setFaq] = useState([]);
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    const controller = new AbortController();
    const fetchFaq = async () => {
      setLoading(true);
      setError(false);
      try {
        const response = await fetch(`${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetFaqSuperadmin`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({}), signal: controller.signal,
        });
        if (!response.ok) throw new Error("FAQ request failed");
        const data = await response.json();
        if (String(data.status) !== "0" || !Array.isArray(data.data)) throw new Error("Invalid FAQ response");
        if (!controller.signal.aborted) setFaq(data.data);
      } catch (err) {
        if (!controller.signal.aborted) setError(true);
      } finally {
        if (!controller.signal.aborted) setLoading(false);
      }
    };
    fetchFaq();
    return () => controller.abort();
  }, [retry]);
  const filteredFaq = useMemo(() => faq.filter(item => `${item.question || ""} ${item.answer || ""}`.toLowerCase().includes(query.trim().toLowerCase())), [faq, query]);
  const jsonLD = faq.length ? JSON.stringify({ "@context": "https://schema.org", "@type": "FAQPage", mainEntity: faq.map(item => ({ "@type": "Question", name: item.question, acceptedAnswer: { "@type": "Answer", text: item.answer } })) }) : null;
  return (
    <div className="billpunch-home resource-page">
      <Helmet><title>Frequently Asked Questions | BillPunch</title><meta name="description" content="Find answers to your questions about BillPunch and get help from our team." />{jsonLD && <script type="application/ld+json">{jsonLD}</script>}</Helmet>
      <Navbar />
      <main>
        <header className="resource-hero"><div className="resource-container"><span className="resource-eyebrow"><FaRegQuestionCircle aria-hidden="true" />Help Center</span><h1>How can we help?</h1><p>Find answers to frequently asked questions about BillPunch.</p><label className="faq-tools"><FaSearch aria-hidden="true" /><input type="search" aria-label="Search frequently asked questions" placeholder="Search questions or keywords…" value={query} onChange={event => setQuery(event.target.value)} /></label></div></header>
        <div className="resource-container faq-layout">
          <section className="faq-list" aria-label="Frequently asked questions" aria-busy={loading}>
            {loading ? <div className="faq-empty" role="status"><h2>Loading answers…</h2><p>Your questions and answers will appear here shortly.</p></div> : error ? <div className="faq-empty" role="alert"><h2>We couldn't load the answers.</h2><p>Please try again, or contact our team for help.</p><button type="button" onClick={() => setRetry(value => value + 1)}>Try Again</button></div> : filteredFaq.length ? <Accordion key={query}>{filteredFaq.map((item, index) => <Accordion.Item eventKey={String(item.pk_faq_id ?? index)} key={item.pk_faq_id ?? index}><Accordion.Header>{item.question}</Accordion.Header><Accordion.Body>{item.answer}</Accordion.Body></Accordion.Item>)}</Accordion> : <div className="faq-empty" role="status"><h2>{query ? "No matching questions" : "Need an answer?"}</h2><p>{query ? "Try a different keyword or ask our support team." : "Our team can help with your questions about BillPunch."}</p>{query && <button type="button" onClick={() => setQuery("")}>Clear Search</button>}</div>}
          </section>
          <aside className="faq-aside"><img src={faqImage} alt="BillPunch customer support illustration" /><div className="resource-help"><h2>Still have questions?</h2><p>Talk to our team for help with your account, features or getting started.</p><Link to="/contact_us">Contact Us <FaArrowRight aria-hidden="true" /></Link></div></aside>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default Billpuncfaq;
